import { useTranslation } from "react-i18next";

const steps = [
  {
    step: "01",
    icon: "ri-search-eye-line",
    titleKey: "process.step0_title",
    descKey: "process.step0_desc",
    durationKey: "process.step0_duration",
  },
  {
    step: "02",
    icon: "ri-compass-3-line",
    titleKey: "process.step1_title",
    descKey: "process.step1_desc",
    durationKey: "process.step1_duration",
  },
  {
    step: "03",
    icon: "ri-tools-line",
    titleKey: "process.step2_title",
    descKey: "process.step2_desc",
    durationKey: "process.step2_duration",
  },
  {
    step: "04",
    icon: "ri-refresh-line",
    titleKey: "process.step3_title",
    descKey: "process.step3_desc",
    durationKey: "process.step3_duration",
  },
];

export default function Process() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 bg-background-100/60 overflow-hidden" id="como-trabajamos">
      <div className="absolute inset-0 grid-pattern opacity-30 pointer-events-none"></div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold">
            <span className="w-2 h-2 rounded-full bg-primary-600"></span>
            {t("process.badge")}
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight">
            <span style={{ color: '#215E88' }}>{t("process.h2_part1")}</span>{' '}
            <span style={{ background: 'linear-gradient(90deg, #215E88, #02B36D)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{t("process.h2_gradient")}</span>
            <span style={{ color: '#215E88' }}>{t("process.h2_part3")}</span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#215E88] leading-relaxed">
            {t("process.description")}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-14 left-[12%] right-[12%] h-px bg-gradient-to-r from-primary-300 via-accent-400 to-primary-300 opacity-60"></div>

          {steps.map((s) => (
            <div key={s.step} className="relative glass-card glow-border rounded-lg p-6 flex flex-col justify-between h-full">
              <div>
                <div className="flex items-center justify-between">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-gradient-to-br from-primary-600 to-accent-500 text-background-50">
                    <span className="w-6 h-6 flex items-center justify-center">
                      <i className={`${s.icon} text-2xl`}></i>
                    </span>
                  </span>
                  <span className="font-heading text-2xl font-bold text-[#215E88]">{s.step}</span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-[#215E88]">{t(s.titleKey)}</h3>
                <p className="mt-2 text-sm text-[#215E88] leading-relaxed">{t(s.descKey)}</p>
              </div>
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-widest text-[#215E88] bg-[#215E88]/10 inline-block px-2.5 py-1 rounded-full self-start">
                {t(s.durationKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}